import type { TaskListResponse } from '../../services/api';

/** One visit's patient-signature state, as every API surface reports it. */
export type PatientSignature = NonNullable<
  TaskListResponse['patient_signature']
>;

/**
 * Screen-reader and tooltip wording for one patient-signature state.
 *
 * Shared by the patient Tasks tab, Hotbox and the visit menu so the three
 * cannot describe the same visit differently. Payroll keeps its own longer
 * copy, which answers a payroll reviewer's "why".
 */
export function patientSignatureLabel(
  state: PatientSignature | null | undefined
): string {
  switch (state) {
    case 'signed':
      return 'Patient signature captured';
    case 'unable_to_sign':
      return 'Patient unable to sign';
    case 'previous_emr':
      return 'Signature stays in External EMR';
    default:
      return 'No patient signature captured';
  }
}
